import { render, staticRenderFns } from "./XeroContacts.vue?vue&type=template&id=7f13c81a&"
import script from "./XeroContacts.vue?vue&type=script&lang=js&"
export * from "./XeroContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports